"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductExtraData = void 0;
const client_1 = require("@apollo/client");
const react_1 = require("@apollo/client/react");
const typings_1 = require("../../typings");
const SearchResultHitService_1 = require("../../services/SearchResultHitService");
const GET_PRODUCT_EXTRA_DATA = (0, client_1.gql) `
  query getProductExtraDataByIds($productsIds: [String!]!) {
    productsById(ids: $productsIds) {
      id
      description
      images {
        title
        url
      }
      attributes {
        name
        type
        values {
          description
        }
      }
    }
  }
`;
const useProductExtraData = (selectedTabKey, productsIds) => {
    const { data, loading } = (0, react_1.useQuery)(GET_PRODUCT_EXTRA_DATA, {
        variables: {
            productsIds: productsIds,
        },
        skip: selectedTabKey !== typings_1.SearchResultTabKeyEnum.Products ||
            !productsIds ||
            productsIds.length === 0,
    });
    const productExtraDataMap = SearchResultHitService_1.searchResultHitService.convertToProductExtraDataMap((data === null || data === void 0 ? void 0 : data.productsById) || []);
    return {
        productExtraDataMap,
        isProductExtraDataLoading: loading,
    };
};
exports.useProductExtraData = useProductExtraData;
